/**
 * Product Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Product template.
 *
 * @namespace product
 */


window.slate = window.slate || {};
window.theme = window.theme || {};

// Track popup display
slate.popUpShown = false;

import  a11ys from './modules/a11y';
import slateCart from './modules/cart'
import slateutil from './modules/utils';
import slateRte from './modules/rte';
import slateSection from './modules/slateSection';
import slateCurrency from './modules/slateCurrency';
import slateImages from './modules/slateImages';
import slateVariant from './modules/variants';
import themeProduct from './modules/themeProduct';
import slateSwatch from './modules/swatch';
import pdpGen from './modules/pdpGen';
//import pdpZoom from './modules/zoom';


// Global impure function for limiting quantity
a11ys();
slateCart();
slateutil();
slateRte();
slateSection();
slateImages();
slateVariant();
themeProduct();
slateSwatch();
pdpGen();
//pdpZoom();

$(document).ready(function() {

	var sections = new slate.Sections(),
		$html = $('html'),
		$body = $('body'),
		$allPopups = $('.popup'),
		$overlay = $('.overlay'),
		$miniCart = $('.mini-cart'),
		$mediaQuery = $('.mq'),
		$mainHeader = $('.main-header'),
		browserWidth = 'small',
		headerHeight = parseInt($body.css('padding-top'), 10),
		previousScroll = 0,
		resizeTimer,
		scrollTimer;

		sections.register('product', theme.Product);

		// Common a11y fixes
		slate.a11y.pageLinkFocus($(window.location.hash));

		$('.in-page-link').on('click', function(evt) {
			slate.a11y.pageLinkFocus($(evt.currentTarget.hash));
		});

		// .trigger('change') so that we can run custom logic for custom variants

		setTimeout(function() {
			document.getElementById('SingleOptionSelector-2') ?
			document.getElementById('SingleOptionSelector-2').dispatchEvent(new Event('change')) : '';
		}, 1200);



		// Target tables to make them scrollable
		var tableSelectors = '.rte table';

		slate.rte.wrapTable({
			$tables: $(tableSelectors),
			tableWrapperClass: 'rte__table-wrapper',
		});

		// Target iframes to make them responsive
		var iframeSelectors =
			'.rte iframe[src*="youtube.com/embed"],' +
			'.rte iframe[src*="player.vimeo"]';

			slate.rte.wrapIframe({
				$iframes: $(iframeSelectors),
				iframeWrapperClass: 'rte__video-wrapper',
				iframeWrapperClassInner: 'rte__video-wrapper-inner'
		});

		// Apply a specific class to the html element for browser support of cookies.
		if (slate.cart.cookiesEnabled()) {
			document.documentElement.className = document.documentElement.className.replace('supports-no-cookies', 'supports-cookies');
		}
});
